import React from 'react';
import SvgIcon from '@home/components/SvgIcon';
import MenuSearch from './MenuSearch';

interface IMenuHeaderWithSearchProps {
  isNormal?: boolean;
  title?: React.ReactNode;
  onSet?: (value: boolean) => void;
}

const MenuHeaderWithSearch: React.FC<IMenuHeaderWithSearchProps> = (props) => {
  const { isNormal = true, title, onSet } = props;

  if (!isNormal) {
    return (
      <div className="navmenu-hd">
        <div
          className="header-width"
          onClick={() => {
            onSet?.(false);
          }}
        >
          <SvgIcon className="header-width-title" type="merit" />
        </div>
      </div>
    );
  }

  return (
    <div className="navmenu-hd dbi-menu-header">
      <div className="navmenu-hd-title">{title}</div>
      <div className="dbi-menu-header__search">
        <MenuSearch />
      </div>
    </div>
  );
};

export default MenuHeaderWithSearch;
